"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FelaFlexbox = exports.ruleKeysFlexbox = exports.FelaRuleFlexbox = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const FelaCache_1 = require("../../fela/FelaCache");
const FelaRuleFlexbox = ({ basis, align, direction, justify, wrap, grow, shrink, overflow, zIndex, position, alignSelf, justifySelf, padding, margin, top, bottom, left, right, gap, gridColumn = "", gridRow = "", radius, aspect, pushMaxWidth, }) => {
    const rules = {
        ...{
            minWidth: 0,
            position,
            zIndex,
            display: "flex",
            overflow,
            flexBasis: basis,
            alignItems: align,
            flexDirection: direction,
            justifyContent: justify,
            flexWrap: wrap,
            flexGrow: grow,
            flexShrink: shrink,
            transition: "background 0.15s ease-out, box-shadow 0.15s ease-out, color 0.15s ease-out",
            alignSelf,
            justifySelf,
            padding,
            margin,
            top,
            bottom,
            left,
            right,
            borderRadius: radius,
            gap,
            // ...(gridColumn && { gridColumn }),
            // ...(gridRow && { gridRow }),
            // ...(aspect && { paddingBottom: `${100 / aspect}%` }),
            // ...(position === "sticky" && {
            //   top: 0,
            // }),
        },
    };
    if (gridColumn) {
        rules.gridColumn = gridColumn;
    }
    if (gridRow) {
        rules.gridRow = gridRow;
    }
    if (aspect) {
        rules.paddingBottom = `${100 / aspect}%`;
    }
    if (pushMaxWidth) {
        rules.width = "100%";
        rules.maxWidth = pushMaxWidth;
    }
    return rules;
};
exports.FelaRuleFlexbox = FelaRuleFlexbox;
exports.ruleKeysFlexbox = [
    "basis",
    "align",
    "direction",
    "justify",
    "wrap",
    "grow",
    "shrink",
    "overflow",
    "zIndex",
    "position",
    "alignSelf",
    "justifySelf",
    "padding",
    "margin",
    "top",
    "bottom",
    "left",
    "right",
    "gap",
    "gridColumn",
    "gridRow",
    "radius",
    "aspect",
    "pushMaxWidth",
];
const FelaFlexbox = ({ children, cssExtra = [], className = "", id, innerRef, style, onClick, onMouseLeave, onMouseEnter, rootProps, ref, cssKey, title, ...props }) => {
    // const { css } = useFela(props);
    const { cachedClass, inlineCss } = (0, FelaCache_1.useFelaCache)();
    // const cssClass = cachedClass(FelaRuleFlexbox, props);
    // console.log(`Rendering FlexBox: ${cssClass}`);
    return ((0, jsx_runtime_1.jsx)("div", { title: title, id: id, onMouseLeave: onMouseLeave, onMouseEnter: onMouseEnter, onClick: onClick, style: style, 
        // className={`${className} ${css(FelaRuleFlexbox, ...cssExtra)}`}
        className: cssExtra.length > 0
            ? `${className} ${cachedClass(exports.FelaRuleFlexbox, props, cssKey ?? exports.ruleKeysFlexbox)} ${inlineCss(cssExtra)}`
            : `${className} ${cachedClass(exports.FelaRuleFlexbox, props, cssKey ?? exports.ruleKeysFlexbox)}`, ...rootProps, children: children }));
};
exports.FelaFlexbox = FelaFlexbox;
